export default __webpack_public_path__ + "static/media/daikon_02-2.37bd6a99.jpg";